import { makeAutoObservable } from 'mobx';
import { DoorType, OpeningType, AttachmentType } from '../config';

export class Attachment {
    _id = null;
    _closetid = null;
    _coordinates = [];
    _pageNo = null;
    _scaleOnPdf = 1;
    _attachmentType = AttachmentType.DOOR;
    _type = DoorType.SINGLE;
    _opening = OpeningType.INSIDE;
    _swing = null;

    constructor(id, closetId, pageNo, swing) {
        makeAutoObservable(this);
        this._id = id;
        this._closetid = closetId;
        this._pageNo = pageNo;
        this._scaleOnPdf = 1;
        this._swing = swing;
    }

    get id() {
        return this._id;
    }

    get coordinates() {
        return this._coordinates;
    }

    get pageNo() {
        return this._pageNo;
    }

    get scaleOnPdf() {
        return this._scaleOnPdf;
    }

    get closetId() {
        return this._closetid;
    }

    get type() {
        return this._type;
    }

    get opening() {
        return this._opening;
    }

    get attachmentType() {
        return this._attachmentType;
    }

    get swing() {
        return this._swing;
    }

    setSwing(swing) {
        this._swing = swing;
    }

    setOpening(opening) {
        this._opening = opening;
    }

    setType(type) {
        this._type = type;
    }

    setClosetId(closetId) {
        this._closetid = closetId;
    }

    setAttachmentType(type) {
        this._attachmentType = type;
    }

    addCoordinate(coordinate) {
        this._coordinates.push(...coordinate);
    }
    isAttachmentInTol(pointToCheck, tol) {
        const polygon = this.coordinates;

        function getDistance(p1, p2) {
            return Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
        }

        function isPointOnSegment(p, a, b, tol) {
            const d1 = getDistance(a, p);
            const d2 = getDistance(b, p);
            const d_ab = getDistance(a, b);

            return Math.abs(d1 + d2 - d_ab) <= tol;
        }

        for (let vertex of polygon) {
            if (getDistance(pointToCheck, vertex) <= tol) {
                return true;
            }
        }

        for (let i = 0; i < polygon.length; i++) {
            const a = polygon[i];
            const b = polygon[(i + 1) % polygon.length];

            if (isPointOnSegment(pointToCheck, a, b, tol)) {
                return true;
            }
        }

        return false;
    }

    findAttachmentByCoordinate(coordinate, tol) {
        for (let i = 0; i < this.coordinates.length; i++) {
            const point = this.coordinates[i];
            const dist = Math.sqrt(
                (point.x - coordinate.x) ** 2 + (point.y - coordinate.y) ** 2,
            );
            if (dist <= tol) {
                return point;
            }
        }
        return null;
    }

    closestAttachmentCoordinate = (coordinate) => {
        let minDist = Infinity;
        let closestPoint = null;
        for (let i = 0; i < this.coordinates.length; i++) {
            const point = this.coordinates[i];
            const dist = Math.sqrt(
                (point.x - coordinate.x) ** 2 + (point.y - coordinate.y) ** 2,
            );
            if (dist < minDist) {
                minDist = dist;
                closestPoint = point;
            }
        }
        return closestPoint;
    };
}
